










































import { Component, Vue } from 'vue-property-decorator'
import { UserDto } from '@/models/dtos/userDto'
import { UserAdminService as _userAdminService } from '@/admin/services/userAdmin.service'
import { PaginationDto } from '@/models/dtos/paginationDto'
import { EmployeeTypeDto } from '@/models/dtos/employeeTypeDto'
import moment from 'moment'
import router from '@/router'

@Component
export default class AdminAccountList extends Vue {
  // Data
  private users: UserDto[] | null = null
  private employeeTypes: EmployeeTypeDto[] | null = null

  private userPagination: PaginationDto = { pageNumber: 1, pageSize: 15 }

  private userItems: {
    id: string;
    fullName: string;
    employeeType: string;
    lastLoginDate: string;
    internalCost: number;
    externalCost: number;
  }[] = []

  private userFields = [
    { key: 'fullName', label: 'Imie i nazwisko', class: 'align-middle' },
    { key: 'lastLoginDate', label: 'Ostatnie logowanie', class: 'align-middle' },
    { key: 'internalCost', label: 'Koszt wewnętrzny', class: 'align-middle' },
    { key: 'externalCost', label: 'Koszt zewnętrzny', class: 'align-middle' },
    { key: 'employeeType', label: 'Typ', class: 'align-middle' },
    { key: 'actions', label: 'Akcje', class: 'align-middle' }
  ]

  // Methods
  private async initUsers() {
    this.users = await _userAdminService.getAll()

    this.userItems = []
    for (const user of this.users) {
      const employeeType = this.employeeTypes!.find(e => e.id === user.employeeType.id)
      if (!employeeType) throw new Error('Can not find employee type')

      this.userItems.push({
        id: user.id,
        fullName: `${user.firstName} ${user.lastName}`,
        employeeType: employeeType.name,
        lastLoginDate: user.lastLoginDate ? moment(user.lastLoginDate).format('llll') : '-',
        internalCost: user.internalCost || employeeType.externalCost,
        externalCost: user.externalCost || employeeType.internalCost
      })
    }
  }

  private async removeUser(id: string) {
    let confirm = false
    try {
      confirm = await this.$bvModal.msgBoxConfirm('Czy na pewno chcesz usunąć tego użytkownika', {
        title: 'Potwierdzenie',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'Usuń',
        cancelTitle: 'Anuluj',
        hideHeaderCancel: false,
        headerClass: 'p-2 border-bottom-0',
        footerClass: 'p-2 border-top-0',
        centered: true
      })
    } catch (e) {}

    if (confirm) {
      await _userAdminService.remove(id)
      this.initUsers()
    }
  }

  private editUser(id: string) {
    router.push({ name: 'AdminAccountEdit', params: { id } })
  }

  // Getters
  private get isLoaded(): boolean {
    return !this.users || !this.employeeTypes
  }

  // Lifecycle
  async created() {
    this.employeeTypes = await _userAdminService.GetEmployeeTypes()
    this.initUsers()
  }
}
